module.exports = __webpack_public_path__ + "img/267-3.5b56e15e.jpg";